import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AccountBalance } from './types'

export type AccountState = {
  data?: AccountBalance
  fetching: boolean
  hasError: boolean
}

const initialState: AccountState = {
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'account',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetchBalances(state) {
      state.fetching = true
    },
    reset() {
      return initialState
    },
    setBalances(state, action: PayloadAction<AccountBalance>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = configSlice
export default configSlice.reducer
